// stores/useDocStatusStore.ts
import { create } from 'zustand';

type TDocumentSavingState = {
  /** Whether the document is currently fully saved. */
  isSaved: boolean;
  setIsSaved: (value: boolean) => void;

  /** Whether there’s an error from the last save attempt. */
  isError: boolean;
  setIsError: (value: boolean) => void;

  /** Timestamp (in ms) of the last successful save, or null if unknown. */
  lastSavedAt: number | null;
  setLastSavedAt: (value: number | null) => void;
};

export const useDocumentSavingStore = create<TDocumentSavingState>((set) => ({
  isSaved: true,
  setIsSaved: (value) => set({ isSaved: value }),

  isError: false,
  setIsError: (value) => set({ isError: value }),

  lastSavedAt: null,
  setLastSavedAt: (value) => set({ lastSavedAt: value }),
}));
